"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M8 7c0 2.2091 1.7909 4 4 4 2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4Zm5.729 13.5362L13.2428 21H18c1.3333 0 2-.75 2-2.25 0-4.5-1.9863-6.75-8-6.75s-8 2.25-8 6.75c0 1.5.6667 2.25 2 2.25h4.7572l-.4862-.4638a1 1 0 0 1-.2823-.9566L11.3255 14h1.349l1.3368 5.5796a1.0003 1.0003 0 0 1-.2823.9566Z", clipRule: "evenodd" })), 'UserHostSolidIcon');
